//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ProfilePage from '~/components/profile/mixins/ProfilePage'
import {helper} from "~/mixins/helper";
import isEmpty from "lodash.isempty"
import isNil from "lodash.isnil"

export default {

    name: 'Profile',

    mixins: [ProfilePage, helper],

    data() {
        return {
            //internalVisit: false,
        }
    },

    async fetch() {

        let routeType = 'company'
        let redirectRoute = 'provider.public.profile'

        const destinationId = this.$route.params.destinationId
        const destinationSlug = this.$route.params.destinationSlug

        let signature = false
        let expire = false

        if(!isNil(this.$route.query.sig) && !isEmpty(this.$route.query.sig)) {

          signature = this.$route.query.sig
          expire = this.$route.query.expire

        }

        if(destinationId) {

            if(destinationSlug) {
                routeType = 'destinationSlug'
            } else {
                routeType = 'destinationId'
            }

            redirectRoute = 'provider.public.profile.destination.slug'
        }

        const payload = {
            company: this.$route.params.id,
            slug: this.$route.params.slug,
            destinationId: destinationId,
            destinationSlug: destinationSlug,
            routeType: routeType,
            signature: signature,
            expire: expire
        }

        try {
            const response = await this.$store.dispatch('profile/GET_COMPANY', payload)
            this.company = response.company
            this.destination = response.destination
            this.page = response.page

            if(response.urlCheck !== true) {

                this.$nuxt.context.redirect(301, { name: redirectRoute, params: {
                        id: this.$route.params.id,
                        slug: this.company.slug ,
                        destinationId: this.destination.id,
                        destinationSlug: this.destination.slug,
                    }})

            }


        } catch (e) {

            this.$logger.captureExceptionAxios(e, true)

            // set status code on server
            if (process.server) {
                this.$nuxt.context.res.statusCode = 404;
            }

            throw new Error('Page not found')

        }

    },

    mounted() {
        this.addEventHandler()
    },

    updated() {
        this.addEventHandler()
    },

    beforeUpdate() {
        this.removeEventHandler()
    },

    destroyed() {
        this.removeEventHandler()
    },

    methods: {

        addEventHandler() {

            this.$bus.$on('track/mailto', this.trackMailto)
            this.$bus.$on('track/phone', this.trackPhone)

            document.addEventListener('copy', this.handleCopyEvent)
        },

        removeEventHandler() {

            this.$bus.$off('track/mailto', this.trackMailto)
            this.$bus.$off('track/phone', this.trackPhone)

            document.removeEventListener('copy', this.handleCopyEvent)
        },
    },

    computed: {

        internalVisit() {

            if(this.authed === false) {
                return false
            }

            if(this.profile.id === this.company.id) {
                return  true
            }

            return false
        }

    },

}

